import React from 'react';
import styled from 'styled-components';
import { Border, Color, Grid } from '../../../app/StyleGuide';
import { SmallRoundedIconButton } from '../../../components/Buttons';
import { SubHeaderWithButton } from '../../../components/Layout';
import curriculumService from '../../../services/curriculumService';
import { AdvancePlanningMaterial } from '../models/advancePlanning';
import { MaterialListItem } from './MaterialListItem';

type VolumeSectionProps = {
  sectionHeader: string;
  sectionId: string;
  materials: AdvancePlanningMaterial[];
  showContents: boolean;
  setShowContents: (id: string) => void;
  className?: string;
};

const VolumeSectionHeaderContainer = styled(SubHeaderWithButton)`
  padding: ${Grid._5} 0;

  h4 {
    margin: 0;
  }
`;

const MaterialList = styled.ul`
  width: 100%;
  list-style: none;
  margin: 0;
  padding: 0;
  border: 1px solid ${Color.Blue._15};
  border-radius: ${Border.radius};
`;

const HeaderTitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

const UpDownIcon = styled.i.attrs({ className: 'fas fa-chevron-down' })<{ isUp: boolean }>`
  transform: rotate(${({ isUp }) => (isUp ? 180 : 0)}deg);
`;

export const VolumeSection = ({
  sectionHeader,
  sectionId,
  materials,
  showContents,
  setShowContents,
  className,
}: VolumeSectionProps) => {
  const downloadMaterial = (path: string, name: string) => curriculumService.downloadVolumeMaterial(path, name);

  const sortedMaterials = materials.sort((a, b) => Number(!!b.fileName) - Number(!!a.fileName));

  return (
    <div className={className} data-tracking-component={'volume-header'} data-tracking-id={sectionHeader}>
      <VolumeSectionHeaderContainer>
        <HeaderTitleContainer>
          <h4>{sectionHeader}</h4>
          <SmallRoundedIconButton onClick={() => setShowContents(sectionId)} aria-label="toggle contents">
            <UpDownIcon isUp={showContents} />
          </SmallRoundedIconButton>
        </HeaderTitleContainer>
      </VolumeSectionHeaderContainer>
      {showContents && (
        <MaterialList>
          {sortedMaterials.map(material => {
            return (
              <MaterialListItem
                key={material.materialId}
                hasAccess={!!material.filePath}
                isPlus={material.package === 'plus'}
                materialName={material.name}
                download={material.filePath ? () => downloadMaterial(material.filePath, material.fileName) : undefined}
              />
            );
          })}
        </MaterialList>
      )}
    </div>
  );
};
